import script from "./BuyHttps.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyHttps.vue?vue&type=script&setup=true&lang=ts"

import "../../assets/css/buy-proxies.css?vue&type=style&index=0&id=24bdb50c&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24bdb50c"]])

export default __exports__